import { render, staticRenderFns } from "./FooterCredit.vue?vue&type=template&id=d2f71f8a&"
import script from "./FooterCredit.vue?vue&type=script&lang=js&"
export * from "./FooterCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterCreditLink: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Footer/FooterCreditLink.vue').default})
